import { type FC } from 'react';

import { type NonEmptyArray } from '@craft/lib';
import { ConditionallyRender, type ConditionallyRenderProps } from '@craft/ui/components/util';

import { type Environment } from '@/src/environment';
import { useClientEnvironment } from '@/src/features/config/hooks';

interface IfMultipleEnvironmentsProps extends Omit<ConditionallyRenderProps, 'show'> {
  readonly environment?: never;
  readonly environments: NonEmptyArray<Environment>;
}

interface IfSingleEnvironmentProps extends Omit<ConditionallyRenderProps, 'show'> {
  readonly environment: Environment;
  readonly environments?: never;
}

type IfEnvironmentProps = IfMultipleEnvironmentsProps | IfSingleEnvironmentProps;

export const IfEnvironment: FC<IfEnvironmentProps> = props => {
  const { env, isReady } = useClientEnvironment();

  if (!isReady) {
    return null;
  } else if (props.environments) {
    const { environments, ...rest } = props;
    return <ConditionallyRender {...rest} show={environments.includes(env.deploymentEnv)} />;
  }
  const { environment, ...rest } = props;
  return <ConditionallyRender {...rest} show={environment === env.deploymentEnv} />;
};
